import React from 'react';
import './ChatStatusIndicator.css';

/**
 * Visual connection status pill for chat surfaces.
 * `status` can be:
 *   - 'connected'     → green pulsing dot, "Connected"
 *   - 'reconnecting'  → amber spinning dot, "Reconnecting…"
 *   - 'disconnected'  → red solid dot, "Offline"
 *   - 'connecting'    → blue pulsing dot, "Connecting…"
 *
 * Used in both WaitingRoom chat header and the in-game ChatBox header so
 * users can tell at a glance whether their messages are flowing.
 */
const ChatStatusIndicator = ({ status = 'disconnected', compact = false }) => {
  const label = {
    connected: 'Connected',
    reconnecting: 'Reconnecting…',
    disconnected: 'Offline',
    connecting: 'Connecting…'
  }[status] || 'Offline';

  return (
    <span
      className={`chat-status chat-status-${status} ${compact ? 'chat-status-compact' : ''}`}
      data-testid={`chat-status-${status}`}
      role="status"
      aria-live="polite"
    >
      <span className="chat-status-dot" aria-hidden="true" />
      {!compact && <span className="chat-status-label">{label}</span>}
    </span>
  );
};

export default ChatStatusIndicator;
